var map = {
	"./config.frontend.business-prod.json": "hc7X",
	"./config.frontend.business-staging.json": "Izkr",
	"./config.frontend.dev.json": "G7VZ",
	"./config.frontend.local.json": "cJyU",
	"./config.frontend.prod-learn.json": "DY/Y",
	"./config.frontend.prod.json": "t0sv",
	"./config.frontend.staging.json": "gHCR",
	"./config.frontend.template.json": "riET"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "E0mP";